__turbopack_context__.v({
  "calloutSection": "PlasmicComplianceCertifications-module__no3Qaa__calloutSection",
  "complianceAndCertificationsBanner": "PlasmicComplianceCertifications-module__no3Qaa__complianceAndCertificationsBanner",
  "contactModal": "PlasmicComplianceCertifications-module__no3Qaa__contactModal",
  "footer": "PlasmicComplianceCertifications-module__no3Qaa__footer",
  "header": "PlasmicComplianceCertifications-module__no3Qaa__header",
  "root": "PlasmicComplianceCertifications-module__no3Qaa__root",
});
